import { render, staticRenderFns } from "./athletesfav.vue?vue&type=template&id=48dddbae&"
import script from "./athletesfav.vue?vue&type=script&lang=js&"
export * from "./athletesfav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VAvatar,VChip,VLazy})
